export const KSA_REGIONS: string[] = [
  'Riyadh',
  'Makkah',
  'Madinah',
  'Eastern Province',
  'Asir',
  'Tabuk',
  'Hail',
  'Northern Borders',
  'Jawf',
  'Najran',
  'Jizan',
  'Qassim',
  'Bahah',
];

export const KSA_CITIES: Record<string, string[]> = {
  Riyadh: [
    'Riyadh', 'Diriyah', 'Al Kharj', 'Dawadmi', 'Al Majmaah', 'Shaqra', 'Az Zulfi',
    'Al Quwayiyah', 'Wadi Ad Dawasir', 'Afif', 'Marat', 'Dilam',
  ],
  Makkah: [
    'Jeddah', 'Makkah', 'Taif', 'Rabigh', 'Qunfudhah', 'Lith', 'Khulais', 'Ranyah',
    'Turbah', 'Al Jumum', 'Al Qunfudhah',
  ],
  Madinah: [
    'Madinah', 'Yanbu', 'Khaybar', 'Al Ula', 'Badr', 'Mahd ad Dhahab', 'Wajh',
  ],
  'Eastern Province': [
    'Dammam', 'Khobar', 'Dhahran', 'Al Ahsa (Hofuf)', 'Qatif', 'Jubail',
    'Hafr Al-Batin', 'Ras Tanura', 'Abqaiq', 'Safwa', 'Saihat',
  ],
  Asir: [
    'Abha', 'Khamis Mushait', 'Bisha', 'Tathlith', 'Dhahran Al Janub', 'Muhayil',
    'Sarat Abidah', 'Rijal Almaa', 'Ahad Rufaidah',
  ],
  Tabuk: [
    'Tabuk', 'Umluj', 'Al Wajh', 'Duba', 'Tayma', 'Haql', 'Sharma',
  ],
  Hail: [
    'Hail', 'Baqaa', 'Al Shinan', 'Jubbah',
  ],
  'Northern Borders': [
    'Arar', 'Rafha', 'Turaif', 'Al Uwayqilah',
  ],
  Jawf: [
    'Sakaka', 'Dawmat Al Jandal', 'Qurrayyat',
  ],
  Najran: [
    'Najran', 'Sharura', 'Hubuna', 'Badr Al Janoub',
  ],
  Jizan: [
    'Jizan', 'Sabya', 'Samtah', 'Abu Arish', 'Farasan', 'Ahad Al Masarihah',
  ],
  Qassim: [
    'Buraydah', 'Unaizah', 'Ar Rass', 'Mulayda', 'Al Mithnab', 'Riyadh Al Khabra',
  ],
  Bahah: [
    'Baha', 'Baljurashi', 'Qilwah', 'Namas', 'Sarat Abidah', 'Al Mandaq',
  ],
};
